import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateMembershipDurationFailAction,
  CreateMembershipDurationRequestAction,
  CreateMembershipDurationSuccessAction,
  DeleteMembershipDurationFailAction,
  DeleteMembershipDurationRequestAction,
  DeleteMembershipDurationSuccessAction,
  FetchMembershipDurationFailAction,
  FetchMembershipDurationRequestAction,
  FetchMembershipDurationSuccessAction,
  MembershipDurationActions,
  stateStatusType,
  UpdateMembershipDurationFailAction,
  UpdateMembershipDurationRequestAction,
  UpdateMembershipDurationSuccessAction,
} from "./actionType";
import { initialState, MembershipDurationState } from "./state";

const fetchMembershipDurationRequest = (
  state: MembershipDurationState,
  action: FetchMembershipDurationRequestAction
) => {
  return updateObject(state, {
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchMembershipDurationSuccess = (
  state: MembershipDurationState,
  action: FetchMembershipDurationSuccessAction
) => {
  return updateObject(state, {
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      membershipDuration: action.payload,
    },
  });
};

const fetchMembershipDurationFail = (
  state: MembershipDurationState,
  action: FetchMembershipDurationFailAction
) => {
  return updateObject(state, {
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      membershipDuration: null,
    },
  });
};

//create
const createMembershipDurationRequest = (
  state: MembershipDurationState,
  action: CreateMembershipDurationRequestAction
) => {
  return updateObject(state, {
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const createMembershipDurationSuccess = (
  state: MembershipDurationState,
  action: CreateMembershipDurationSuccessAction
) => {
  const existingData =
    state.fetchmembershipDurationState.membershipDuration ?? [];
  return updateObject(state, {
    genericMembershipDurationState: {
      ...state.genericMembershipDurationState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      membershipDuration: [...existingData, action.payload],
    },
  });
};

const createMembershipDurationFail = (
  state: MembershipDurationState,
  action: CreateMembershipDurationFailAction
) => {
  return updateObject(state, {
    genericMembershipDurationState: {
      ...state.genericMembershipDurationState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
  });
};

//update
const updateMembershipDurationRequest = (
  state: MembershipDurationState,
  action: UpdateMembershipDurationRequestAction
) => {
  return updateObject(state, {
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const updateMembershipDurationSuccess = (
  state: MembershipDurationState,
  action: UpdateMembershipDurationSuccessAction
) => {
  const newData =
    state.fetchmembershipDurationState.membershipDuration?.map((item)=> item.id === action.payload.id ? action.payload : item) ?? [];
  return updateObject(state, {
    genericMembershipDurationState: {
      ...state.genericMembershipDurationState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      membershipDuration: [...newData],
    },
  });
};

const updateMembershipDurationFail = (
  state: MembershipDurationState,
  action: UpdateMembershipDurationFailAction
) => {
  return updateObject(state, {
    genericMembershipDurationState: {
      ...state.genericMembershipDurationState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
  });
};
//delete
const deleteMembershipDurationRequest = (
  state: MembershipDurationState,
  action: DeleteMembershipDurationRequestAction
) => {
  return updateObject(state, {
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: true,
      error: null,
      status: null,
      delete: null
    },
  });
};

const deleteMembershipDurationSuccess = (
  state: MembershipDurationState,
  action: DeleteMembershipDurationSuccessAction
) => {
    var newMembershipDuration = state.fetchmembershipDurationState.membershipDuration?.filter(
    (item) => item.id !== action.payload
  ) ?? [];
  return updateObject(state, {
    genericMembershipDurationState: {
      ...state.genericMembershipDurationState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete:null
    },
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      delete:null,
      membershipDuration: [...newMembershipDuration]

    },
  });
};

const deleteMembershipDurationFail = (
  state: MembershipDurationState,
  action: DeleteMembershipDurationFailAction
) => {
  return updateObject(state, {
    genericMembershipDurationState: {
      ...state.genericMembershipDurationState,
      isLoading: false,
      delete:action.payload,
      status: stateStatusType.FAILED,
    },
    fetchmembershipDurationState: {
      ...state.fetchmembershipDurationState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
  });
};
const fetchMembershipDurationReducer = (
  state = initialState,
  action: MembershipDurationActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_MEMBERSHIP_DURATION_REQUEST:
      return fetchMembershipDurationRequest(state, action);
    case actionTypes.FETCH_MEMBERSHIP_DURATION_SUCCESS:
      return fetchMembershipDurationSuccess(state, action);
    case actionTypes.FETCH_MEMBERSHIP_DURATION_FAIL:
      return fetchMembershipDurationFail(state, action);
    case actionTypes.CREATE_MEMBERSHIP_DURATION_REQUEST:
      return createMembershipDurationRequest(state, action);
    case actionTypes.CREATE_MEMBERSHIP_DURATION_SUCCESS:
      return createMembershipDurationSuccess(state, action);
    case actionTypes.CREATE_MEMBERSHIP_DURATION_FAIL:
      return createMembershipDurationFail(state, action);
    case actionTypes.UPDATE_MEMBERSHIP_DURATION_REQUEST:
      return updateMembershipDurationRequest(state, action);
    case actionTypes.UPDATE_MEMBERSHIP_DURATION_SUCCESS:
      return updateMembershipDurationSuccess(state, action);
    case actionTypes.UPDATE_MEMBERSHIP_DURATION_FAIL:
      return updateMembershipDurationFail(state, action);
    case actionTypes.DELETE_MEMBERSHIP_DURATION_REQUEST:
      return deleteMembershipDurationRequest(state, action);
    case actionTypes.DELETE_MEMBERSHIP_DURATION_SUCCESS:
      return deleteMembershipDurationSuccess(state, action);
    case actionTypes.DELETE_MEMBERSHIP_DURATION_FAIL:
      return deleteMembershipDurationFail(state, action);
    default:
      return state;
  }
};

export default fetchMembershipDurationReducer;
